const MultipleBatchTypeNotSupported = 'Multiple Batch Types Not Supported';
const StandardBatchTypeNotSupported = 'Standard Batch Types Not Supported';
const SomethingWentWrong = "Something went wrong while processing the batch";

export {
    MultipleBatchTypeNotSupported,
    StandardBatchTypeNotSupported,
    SomethingWentWrong
};